<template>
  <section
    class="pentagon-year"
    data-cy="intro-year"
    :aria-labelledby="headingId"
  >
    <h3 :id="headingId" class="pentagon-year__title text-center">{{ year.year }}</h3>

    <ul class="pentagon-year__members">
      <Lid
        v-for="(member, index) in year.members"
        :key="`${index}-${member}`"
        :member="member"
      />
    </ul>
  </section>
</template>

<script>
import Lid from './Lid.vue';

export default {
  name: 'Jaar',
  props: {
    year: {
      type: Object,
      required: true,
    },
    // Keeps the heading ids unique when a year appears in both sections.
    variant: {
      type: String,
      default: 'active',
    },
  },
  components: {
    Lid,
  },
  computed: {
    headingId() {
      return `year-${this.variant}-${this.year.year}`;
    },
  },
};
</script>

<style>
  .pentagon-year {
    padding: 1.5rem 0 1.75rem;
  }

  .pentagon-year__title {
    position: relative;
    margin-bottom: 1.25rem;
    padding-bottom: 0.75rem;
    font-size: 1.75rem;
  }

  /* A thin ornamental rule under the year. */
  .pentagon-year__title::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    background: linear-gradient(
      to right,
      rgba(255, 215, 0, 0),
      rgba(255, 215, 0, 0.5),
      rgba(255, 215, 0, 0)
    );
  }

  .pentagon-year__members {
    margin: 0 auto;
    padding: 0;
    max-width: 60rem;
    list-style: none;
    text-align: center;
  }
</style>
